import { Injectable } from '@angular/core';
import { SCALE } from '../helper/constant';
import { LogicService } from './logic.service';
import { EnglishOffline, GameHelpOffline, Setting } from '../../interfaces/cards.interface';
import { CardApi } from '../../Api/services/custom';
import { Account, Card } from '../../Api/models';
import * as moment from 'moment';
import { Platform } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { ENGLISH_CARD } from '../helper/englishCards';
import { LoopBackAuth } from '../../Api/services/core';

let music;
let that;

@Injectable({
    providedIn: 'root'
})
export class MapService {
    maps = {
        window: {
            width: 0,
            height: 0
        },
        object_size: {
            width: 0,
            height: 0
        }
    };
    soundMute = true;
    soundUrl = '';
    gameSetting: Setting = {
        sound: true,
        language: 'vi',
        lock: 'lock',
        day: 0,
        kind: 'day'
    };
    englishCards: EnglishOffline[] = ENGLISH_CARD;
    videoHelps: GameHelpOffline[] = [];
    deviceId = '';
    customerMail = '';
    platformIsDesktop = true;
    platformAll: string[];
    resumDays = 0;
    authAccount = new Account();
    isOnline = false;
    iOSEnableSubscribe = false;

    constructor(private logicService: LogicService,
                private cardApi: CardApi,
                private platform: Platform,
                private domSanitizer: DomSanitizer,
                private auth: LoopBackAuth) {
        that = Object.create(this.constructor.prototype);
    }

    getMapsProperties() {
        return this.maps;
    }

    setOnline(data: boolean) {
        this.isOnline = data;
    }

    setCurrentAccount(account: Account) {
        this.authAccount = account;
    }

    clearAccount() {
        this.authAccount = new Account();
    }

    getCurrentAccount() {
        return this.authAccount;
    }

    activeCard(inputCode: string, deviceID: string) {
        return new Promise((resolve, reject) => {
            let result = 'error';
            const activeCode = `"` + inputCode + ',' + deviceID + ',' + '0' + `"`;
            this.cardApi.activeCardGame(activeCode)
                .subscribe((card: Card) => {
                    if (card && card.id) {
                        this.gameSetting.deviceId = this.deviceId;
                        if (card.days === 0) {
                            this.gameSetting.kind = 'never';
                            result = 'success';
                            this.saveSetting(this.gameSetting).then((val2) => {
                                if (val2) {
                                    resolve(result);
                                }
                            }).catch(e => console.log('activeCard', e));
                        } else {
                            const diffDay = moment().diff(card.activedAt, 'days');
                            // console.log('diffDay', diffDay);
                            if ((card.days - diffDay) > 0) {
                                this.gameSetting.lock = 'unlock';
                                this.gameSetting.day = card.days;
                                this.gameSetting.kind = 'day';
                                this.gameSetting.activeAt = card.activedAt;
                                this.gameSetting.currentDate = moment();
                                result = 'success';
                                this.saveSetting(this.gameSetting).then((val2) => {
                                    if (val2) {
                                        resolve(result);
                                    }
                                }).catch(e => console.log('activeCard', e));
                            } else {
                                resolve('expired');
                            }
                        }
                        // console.log('ActiveCard Success', card);
                    } else {
                        console.log('ActiveCard error, card not found');
                        resolve('ok');
                    }
                }, error1 => {
                    console.log('ActiveCard error', error1);
                    reject(error1);
                });
        });
    }

    initMapsProperties(el: any) {
        this.initWindow(el);
    }

    initWindow(el: any) {
        let w = 0;
        let h = 0;
        if (el && el.nativeElement && el.nativeElement.offsetWidth && el.nativeElement.offsetHeight) {
            w = el.nativeElement.offsetWidth;
            h = el.nativeElement.offsetHeight;
        } else {
            w = window.innerWidth;
            h = window.innerHeight;
        }

        const isPortrait = window.innerHeight > window.innerWidth;
        if (isPortrait) {
            this.maps.window.width = w;
            this.maps.window.height = Math.round(w * (1079 / 1915));
        } else {
            this.maps.window.width = w;
            this.maps.window.height = h;
        }

        this.maps.object_size.width = Math.floor(this.maps.window.width / SCALE.scale.w);
        this.maps.object_size.height = Math.floor(this.maps.window.height / SCALE.scale.h);
        if (this.maps.object_size.height % 2 !== 0) {
            this.maps.object_size.height += 1;
        }
        if (this.maps.object_size.width % 2 !== 0) {
            this.maps.object_size.width += 1;
        }
    }

    enableSound() {
        this.soundMute = true;
        if (music) {
            music.muted = false;
        }
    }

    disableSound() {
        this.soundMute = false;
        if (music) {
            music.muted = true;
        }
    }

    getAccountId() {
        return this.authAccount.id || 0;
    }

    getSoundConfig() {
        return this.soundMute;
    }

    private pendingMusicAutoPlay = false;
    private autoplayListenerAttached = false;

    setupAutoplayUnlocker() {
        if (this.autoplayListenerAttached) return;
        this.autoplayListenerAttached = true;

        const unlockEvents = ['click', 'touchstart', 'pointerdown', 'keydown'];
        const unlockHandler = () => {
            this.playAllVideosOnPage();

            if (music) {
                if (music.paused || this.pendingMusicAutoPlay) {
                    const res = music.play();
                    if (res && res.then) {
                        res.then(() => {
                            this.pendingMusicAutoPlay = false;
                            if (this.gameSetting && this.gameSetting.sound === false) {
                                this.disableSound();
                            } else {
                                this.enableSound();
                            }
                        }).catch(e => console.log('Autoplay unlock retry music error:', e));
                    } else {
                        this.pendingMusicAutoPlay = false;
                        if (this.gameSetting && this.gameSetting.sound === false) {
                            this.disableSound();
                        } else {
                            this.enableSound();
                        }
                    }
                } else if (this.gameSetting && this.gameSetting.sound !== false && music.muted) {
                    this.enableSound();
                }
            }
        };

        unlockEvents.forEach(eventType => {
            window.addEventListener(eventType, unlockHandler, { capture: true });
        });
    }

    requestFullscreen() {
        try {
            const doc: any = document;
            const docEl: any = document.documentElement;
            const req = docEl.requestFullscreen || docEl.webkitRequestFullScreen || docEl.mozRequestFullScreen || docEl.msRequestFullscreen;
            if (req && !doc.fullscreenElement && !doc.webkitFullscreenElement && !doc.mozFullScreenElement && !doc.msFullscreenElement) {
                req.call(docEl).catch((e: any) => console.log('Fullscreen request error:', e));
            }
        } catch (e) {
            console.log('requestFullscreen error:', e);
        }
    }

    setupPhaserInput(game: any) {
        if (!game || !game.input) return;

        if (game.input.touch) {
            game.input.touch.preventDefault = true;
        }

        if (screen && screen.orientation && (screen.orientation as any).lock) {
            (screen.orientation as any).lock('landscape').catch(() => {});
        }
    }

    playAllVideosOnPage() {
        try {
            const videos = document.querySelectorAll('video');
            videos.forEach((video: HTMLVideoElement) => {
                if (video) {
                    video.muted = true;
                    video.playsInline = true;
                    if (video.paused) {
                        video.play().catch(e => console.log('Video play catch:', e));
                    }
                }
            });
        } catch (e) {
            console.log('playAllVideosOnPage error:', e);
        }
    }

    playMusic(file: string) {
        try {
            if (music) {
                music.pause();
                music.currentTime = 0;
                music = undefined;
            }
            this.soundUrl = file;
            music = new Audio(file);
            music.type = 'audio/mpeg';
            if (typeof music.loop === 'boolean') {
                music.loop = true;
            } else {
                music.addEventListener('ended', function() {
                    this.currentTime = 0;
                    this.play();
                }, false);
            }
            music.volume = 0.8;
            this.pendingMusicAutoPlay = true;

            const playPromise = music.play();

            if (playPromise !== undefined) {
                playPromise.then(() => {
                    this.pendingMusicAutoPlay = false;
                    if (this.gameSetting && this.gameSetting.sound === false) {
                        this.disableSound();
                    } else {
                        this.enableSound();
                    }
                }).catch(error => {
                    console.log('Play sound pending user interaction', error);
                    this.pendingMusicAutoPlay = true;
                    this.setupAutoplayUnlocker();
                });
            }
            this.setupAutoplayUnlocker();
        } catch (e) {
            console.log(e);
        }
        return music;
    }

    getMusic() {
        return music;
    }

    stopMusic() {
        if (music) {
            music.pause();
        }
    }

    resumeMusic() {
        if (music) {
            const playPromise = music.play();

            if (playPromise !== undefined) {
                playPromise.then(_ => {
                    // Automatic playback started!
                    // Show playing UI.
                })
                    .catch(error => {
                        // Auto-play was prevented
                        // Show paused UI.
                    });
            }
        }
    }

    getSoundIsPlay() {
        return this.soundUrl;
    }

    saveSetting(data) {
        return new Promise((resolve, reject) => {
            this.logicService.setSetting(data).then((val) => {
                this.gameSetting = data;
                this.gameSetting.sound ? this.enableSound() : this.disableSound();
                resolve(val);
            }).catch(() => {
                reject();
            });
        });
    }

    getSetting() {
        return new Promise((resolve) => {
            this.logicService.getSetting().then((val: Setting) => {
                try {
                    const todayDate = moment();
                    if (val) {
                        this.gameSetting = val;
                        if (todayDate < moment(this.gameSetting.currentDate)) {
                            this.gameSetting.lock = 'lock';
                        } else {
                            this.gameSetting.currentDate = todayDate;
                            const diffDay = todayDate.diff(this.gameSetting.activeAt, 'days');
                            this.resumDays = this.gameSetting.lock === 'lock' ? 0 : (this.gameSetting.day - diffDay);
                            if (this.gameSetting && this.gameSetting.kind === 'day' && this.resumDays <= 0) {
                                this.gameSetting.lock = 'lock';
                            }
                        }
                    }
                } catch (e) {
                    console.log('mapService getSetting error', e);
                }
                resolve(this.gameSetting);
            }).catch((e) => {
                console.log('mapService getSetting catch error', e);
                resolve(this.gameSetting);
            });
        });
    }

    useSetting(data: Setting) {
        this.gameSetting = data;
        this.soundMute = this.gameSetting.sound ? true : false;
        this.soundMute ? this.enableSound() : this.disableSound();
    }

    getLanguage() {
        return this.gameSetting.language ? this.gameSetting.language : 'vi';
    }

    getGameLock() {
        return this.gameSetting.lock ? this.gameSetting.lock : 'lock';
    }

    setEnglishCards(data: EnglishOffline[]) {
        this.englishCards = data;
    }

    setVideoHelp(data: GameHelpOffline[]) {
        this.videoHelps = data;
    }

    getVideoHelp() {
        return this.videoHelps;
    }

    getEnglishCards() {
        return this.englishCards;
    }

    getActiveGame() {
        if (this.gameSetting && this.gameSetting.lock === 'unlock') {
            return 'unlock';
        }
        return 'lock';
    }

    initDeviceId() {
        this.authAccount = this.auth.getCurrentUserData();
        if (this.authAccount && this.authAccount.id) {
            console.log('get device id sucees', this.authAccount.id);
            this.deviceId = this.authAccount.id.toString(10);
            console.log(this.deviceId);
            return this.deviceId;
        }
        console.log('get device id error');
        return;
    }

    getDeviceId() {
        this.initDeviceId();
        return this.deviceId ? this.deviceId : '';
    }

    getAuthEmail() {
        this.authAccount = this.auth.getCurrentUserData();
        if (this.authAccount && this.authAccount.id) {
            console.log('get customer mail', this.authAccount.email);
            this.customerMail = this.authAccount.email;
            console.log(this.customerMail);
            return this.customerMail;
        }
        console.log('get customer mail error');
        return;
    }

    getGameSetting() {
        return this.gameSetting;
    }

    getCardActiveKind() {
        return this.gameSetting.kind ? this.gameSetting.kind : 'error';
    }

    getCardActiveDay() {
        return this.resumDays ? this.resumDays : 0;
    }

    setPlatformIsDesktop(value: boolean) {
        this.platformIsDesktop = value;
    }

    getPlatformIsDesktop() {
        return this.platformIsDesktop;
    }

    async readAllPlatform() {
        const platform = this.platform.platforms();
        if (platform) {
            this.platformAll = platform;
            return this.platformAll;
        } else {
            return;
        }


    }

    getAllPlatForm() {
        return this.platformAll;
    }

    getTrust(url: string) {
        // const path = dir + name;
        const path = this.domSanitizer.bypassSecurityTrustUrl(url);
        // console.log('getTrust', path.toString());
        return path;
    }

    setIOSEnableSubscribe(data: boolean) {
        this.iOSEnableSubscribe = data;
    }

    getIOSEnableSubscribe() {
        return this.iOSEnableSubscribe;
    }
}

